import type { ArticleContent } from './types';
import { articles as en } from './en';
import { articles as fr } from './fr';
import { articles as da } from './da';
import { articles as de } from './de';

const articlesByLang: Record<string, ArticleContent[]> = {
  en,
  fr,
  da,
  de,
};

export function getArticles(lang: string): ArticleContent[] {
  return articlesByLang[lang] ?? en;
}

export function getArticle(lang: string, slug: string): ArticleContent | undefined {
  const list = getArticles(lang);
  return list.find((a) => a.slug === slug) ?? list[0];
}

export type { ArticleContent } from './types';